exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-MajorError {\n  text-align: center;\n  padding: 20px;\n  max-width: 900px;\n  overflow: auto;\n}\n.cs-MajorError__message {\n  line-height: 1.3em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/MajorError/MajorError.less
// module id = 839
// module chunks = 0